import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from 'recharts';

interface ArchiveChartsProps {
  byModule: Array<{ name: string; value: number }>;
  byStatus: Array<{ name: string; value: number }>;
}

const STATUS_COLORS: Record<string, string> = {
  Valid: '#10b981',
  Pending: '#f59e0b',
  Expired: '#ef4444',
  Draft: '#6b7280',
  Rejected: '#dc2626',
};

export default function ArchiveCharts({ byModule, byStatus }: ArchiveChartsProps) {
  return (
    <div className="grid lg:grid-cols-2 gap-6">
      {/* By Module */}
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Distribusi per Modul</CardTitle>
        </CardHeader>
        <CardContent>
          {byModule.length > 0 ? (
            <ResponsiveContainer width="100%" height={250}>
              <BarChart data={byModule}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="value" fill="#3b82f6" />
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <div className="h-[250px] flex items-center justify-center text-gray-500">
              Belum ada dokumen
            </div>
          )}
        </CardContent>
      </Card>

      {/* By Status */}
      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Status Dokumen</CardTitle>
        </CardHeader>
        <CardContent>
          {byStatus.length > 0 ? (
            <div className="flex items-center gap-6">
              <ResponsiveContainer width="50%" height={200}>
                <PieChart>
                  <Pie
                    data={byStatus}
                    cx="50%"
                    cy="50%"
                    innerRadius={50}
                    outerRadius={80}
                    paddingAngle={2}
                    dataKey="value"
                  >
                    {byStatus.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={STATUS_COLORS[entry.name] || '#6b7280'} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
              <div className="space-y-2">
                {byStatus.map(item => (
                  <div key={item.name} className="flex items-center gap-3">
                    <div
                      className="w-3 h-3 rounded-full"
                      style={{ backgroundColor: STATUS_COLORS[item.name] }}
                    />
                    <div>
                      <p className="text-sm font-medium">{item.name}</p>
                      <p className="text-xs text-gray-500">{item.value} dokumen</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <div className="h-[200px] flex items-center justify-center text-gray-500">
              Belum ada data
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
